import { Controller } from "@hotwired/stimulus"

// Landing-page theme switcher. Flips data-theme on <html> and persists the
// choice in a plain cookie. No network round-trip — the whole landing page
// re-themes via CSS transitions on the wrapper element.
export default class extends Controller {
  static targets = ["option", "switch", "lightImage", "darkImage"]
  static values = { current: String, transitionMs: { type: Number, default: 450 } }

  toggle(event) {
    event.preventDefault()
    const next = event.currentTarget.dataset.landingThemeTheme
    if (!next || next === this.currentValue) return

    this.currentValue = next
    this.#persistCookie(next)
    this.#applyTheme(next)
    this.#updateOptions(next)
  }

  flip(event) {
    event.preventDefault()
    const next = this.currentValue === "dark" ? "light" : "dark"
    this.currentValue = next
    this.#persistCookie(next)
    this.#applyTheme(next)
    this.#updateOptions(next)
  }

  currentValueChanged() {
    this.#updateOptions(this.currentValue)
  }

  #applyTheme(theme) {
    const html = document.documentElement
    html.classList.add("landing-theme-transitioning")
    html.setAttribute("data-theme", theme === "dark" ? "floosyo-dark" : "floosyo")

    window.clearTimeout(this.transitionTimer)
    this.transitionTimer = window.setTimeout(() => {
      html.classList.remove("landing-theme-transitioning")
    }, this.transitionMsValue)
  }

  #updateOptions(theme) {
    if (this.hasSwitchTarget) {
      this.switchTarget.dataset.activeTheme = theme
    }
    if (!this.hasOptionTarget) return
    this.optionTargets.forEach((btn) => {
      const isActive = btn.dataset.landingThemeTheme === theme
      btn.setAttribute("aria-pressed", isActive ? "true" : "false")
      btn.dataset.active = isActive ? "true" : "false"
    })
  }

  #persistCookie(theme) {
    const oneYear = 60 * 60 * 24 * 365
    document.cookie = `floosyo_landing_theme=${theme}; path=/; max-age=${oneYear}; samesite=lax`
  }
}
